import { CpmButton } from '../../../components/design-system';

interface SectionErrorProps {
    title: string;
    body: string;
    onRetry?: () => void;
    retrying?: boolean;
    retryLabel?: string;
}

/** Inline panel error matching Overview design (shortfall card + Retry). */
export default function SectionError({
    title,
    body,
    onRetry,
    retrying = false,
    retryLabel,
}: SectionErrorProps) {
    return (
        <div
            className="flex flex-col items-start rounded-[10px] bg-[var(--cpm-shortfall-bg)] border border-[var(--cpm-shortfall-border)]"
            style={{ gap: 12, padding: '26px 20px' }}
        >
            <span
                className="inline-flex items-center text-[var(--cpm-shortfall-text)]"
                style={{ gap: 8, fontSize: 13.5, fontWeight: 800 }}
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="12" cy="12" r="10" />
                    <path d="m15 9-6 6" />
                    <path d="m9 9 6 6" />
                </svg>
                {title}
            </span>
            <span
                className="text-[var(--cpm-shortfall-text-med)]"
                style={{ fontSize: 12.5, fontWeight: 600, lineHeight: 1.45 }}
            >
                {body}
            </span>
            {onRetry ? (
                <CpmButton
                    variant="outline"
                    size="sm"
                    disabled={retrying}
                    leadingIcon={retrying ? <span className="cpm-spin" /> : undefined}
                    onClick={onRetry}
                >
                    {retryLabel ?? (retrying ? 'Retrying…' : 'Retry')}
                </CpmButton>
            ) : null}
        </div>
    );
}
